export default "__VITE_ASSET__b64d1c87__"